import qs from 'qs';
import _ from 'lodash';
import { sizes } from 'utils/styledHelpers';
import NavigationService from 'services/navigationService';
import { strToBool } from 'utils/utils';
import type { ParsedQs } from 'qs';
import { AppColumns } from 'types/table';
import type { QueryParams } from './types';

interface SetQueryOptions {
  replace?: boolean;
}

const FilterService = {
  filterState: false as boolean,

  getExpand(expand?: string, defaultExpand?: boolean): boolean | undefined {
    return (window.innerWidth > sizes.sm && strToBool(expand, defaultExpand ?? false));
  },

  getQuery(query: string): ParsedQs {
    return qs.parse(query, {
      ignoreQueryPrefix: true,
    });
  },

  setQuery(
    params: QueryParams,
    changeState = true,
    replaceHistory?: boolean,
  ): void {
    if (changeState) {
      FilterService.filterState = !FilterService.filterState;
    }

    const filtered = _.pickBy(
      params,
      (val) => _.identity(val) || _.isBoolean(val),
    );

    const queryString = qs.stringify(filtered);

    NavigationService(`?${queryString}`, {
      replace: replaceHistory,
    } as SetQueryOptions);
  },

  getTableCols<T>(
    field: ParsedQs[keyof ParsedQs] | string | undefined,
    order: ParsedQs[keyof ParsedQs] | 'ascend' | 'descend' | null | undefined,
    cols: AppColumns<T>,
  ): AppColumns<T> {
    const normalizedField = typeof field === 'string' ? field : undefined;
    const normalizedOrder = order === 'ascend' || order === 'descend' ? order : null;

    return cols.map((column) => (column.dataIndex
      ? { ...column, sortOrder: column.dataIndex === normalizedField ? normalizedOrder : null }
      : column));
  },

  getFilterData<T extends QueryParams>(query: T): Partial<T> {
    return _.pickBy(
      {
        ...query,
        expand: undefined,
        pageNumber: undefined,
        tab: undefined,
        type: undefined,
        orderType: undefined,
        orderField: undefined,
        oddsFormat: undefined,
      },
      (val) => _.identity(val) || _.isBoolean(val),
    ) as Partial<T>;
  },
};

export default FilterService;
